package com.sweetlime.bingeamigo.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class UserReview(
    val uid: String = "",
    val contentType: String = "",
    val contentId: String = "",
    val rating: Double = 0.0,
    val review: String? = null,
    val displayName: String = "",
    val userAvatar: String = "",
    val contentTitle: String = "",
    val contentPosterPath: String = "",
    val timestamp: Timestamp? = null,
    val likeCount: Int = 0,
    @Transient val docId: String = ""
)